<template>
  <div class="blog-block blog-wall">
    <div class="blog-wall__container">
      <div v-for="(image, index) in data.images" :key="index">
        <img :src="image.image.url" :alt="image.name" @load="emitLoad">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'blog-wall',

  props: ['data'],

  methods: {
    emitLoad() {
      this.$parent.$emit('reload-boundries');
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-wall {
  &__container {
    width: 100%;

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: calc((100vw / 32) * 0.5);
    grid-row-gap: calc((100vw / 32) * 0.5);

    @include mq($until: ipadL) {
      display: block;
    }
  }
}
</style>
